export default function NormalSelectInputField(props) {
  const values = props.values;
  const required = props.isRequired || props.required;
  return (
    <div>
      <div className="font-semibold uppercase text-[12px] text-gray-600">
        {props.title}{" "}
        <span className="text-red-500">{required ? "*" : null}</span>
      </div>
      <select
        onChange={props.disabled ? () => {} :props.onChange}
        value={props.value}
        required={required}
        className={`border text-sm border-gray-300 focus:border-primary duration-300 bg-inherit p-2 w-full rounded-[4px] font-medium ${props.disabled ? 'bg-gray-300 cursor-not-allowed pointer-events-none opacity-70': 'bg-inherit pointer-events-auto cursor-auto opacity-100'}`}
      >
        <option value="">--Select--</option>
        {values.map((item, index) =>
          item?.value ? (
            <option key={index} value={item.value} className="block">
              {item.label}
            </option>
          ) : (
            <option key={index} value={item} className="block">
              {item}
            </option>
          )
        )}
      </select>
    </div>
  );
}
